import { render, staticRenderFns } from "./feedbacks-as-donor.vue?vue&type=template&id=f248a10a"
import script from "./feedbacks-as-donor.vue?vue&type=script&lang=js"
export * from "./feedbacks-as-donor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports